import React, { useState, useEffect } from 'react';
import Socials from './Socials';
import MobileNav from './MobileNav';
import {MdCameraRoll} from 'react-icons/md'
import { Link } from 'react-router-dom';
import '../index.css'

const Header = () => {

  const [activePage, setActivePage] = useState("")
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))

  console.log(user)

  useEffect(() => {
    const token = user?.token;
    setUser(JSON.parse(localStorage.getItem('profile')));
  }, [])

  return (
    <header className='fixed w-full px-[30px] lg:px-[120px] z-30 h-[100px] lg:h-[140px] flex items-center backdrop-blur-xl animate-fade-in'>
      <div className='flex flex-col lg:flex-row lg:items-center w-full justify-between'>

        <Link
          to={'/'}
          className='max-w-[250px]'
        >
          <div className='flex'>
          <MdCameraRoll className='mt-2 mr-2 text-4xl bg-yellow-400 p-2 rounded-full'/>
          <h1 className='h1 text-2xl mt-2'>Soroush Bahrami</h1>
          </div>
  
        </Link>

        {/* nav - initially hidden - show on desktop mode */}
        
          <nav
          className='hidden xl:flex gap-x-12 font-semibold flex-grow justify-center'
        >
          <Link
            to={'/portfolio'}
            onClick={() => setActivePage("Home")}
            className={`text-black border-2 border-white rounded-lg p-3 hover:scale-110 transition ${activePage === "Home" ? 'border-yellow-400 bg-white' : ''}`}
          >
            Home
          </Link>

          <Link
            to={'/works'}
            onClick={() => setActivePage("Work")}
            className={`text-black border-2 border-white rounded-lg p-3 hover:scale-110 transition ${activePage === "Work" ? 'border-yellow-400 bg-white' : ''}`}
          >
            Work
          </Link>
        
          <Link
            to={'/about'}
            onClick={() => setActivePage("About")}
            className={`text-black  border-2 border-white rounded-lg p-3 hover:scale-110 transition ${activePage === "About" ? 'border-yellow-400 bg-white' : ''}`}
          >
            About
          </Link>

          <Link
            to={'/contact'}
            onClick={() => setActivePage("Contact")}
            className={`text-black  border-2 border-white rounded-lg p-3 hover:scale-110 transition ${activePage === "Contact" ? 'border-yellow-400 bg-white' : ''}`}
          >
            Contact
          </Link>
        </nav>
        
        
      </div>
      {/* socials */}
      <Socials />

      {/* mobile nav */}
      <MobileNav />
    </header>
  );
};

export default Header;
